module.exports = __webpack_public_path__ + "static/media/growth.45f69607.jpg";